import { render } from "./z-confirm.vue?vue&type=template&id=50b4f0da&scoped=true&lang=pug"
import script from "./z-confirm.vue?vue&type=script&setup=true&lang=js"
export * from "./z-confirm.vue?vue&type=script&setup=true&lang=js"

import "./z-confirm.vue?vue&type=style&index=0&id=50b4f0da&scoped=true&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b4f0da"]])

export default __exports__